import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Transform = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, updatePivotControls } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            updatePivotControls: state.updatePivotControls
        }))
    );

    const hasSelection = (() => {
        for (const _ in articleInstanceSelections) {
            return true;
        }
        return false;
    })();

    return (
        <Menu.Item
            disabled={!hasSelection}
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon="transform"
                />
            }
            rightSection={<Text className="action-menu-entry-decoration-text text-right text-[13px]">{ShortcutAction.Transform}</Text>}
            onClick={() => updatePivotControls()}
        >
            {t('transform')}
        </Menu.Item>
    );
};
